// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__14e2J","balanceDisclaimer":"posDashboard_balanceDisclaimer__3K595"};